import "babel-polyfill";

require("es5-shim");
require("es5-shim/es5-sham");
require("console-polyfill");

// jQuery Extend
require("./common/UMD/jQueryExtend");

import React from "react";
import ReactDOM from "react-dom";
import { Router, browserHistory } from "react-router";
import Routers from "./common/routes";
import { Provider } from "react-redux";
import { syncHistoryWithStore } from "react-router-redux";
import configureStore from "./common/store/configureStore";
import { Base64 } from 'js-base64'

const storeData = JSON.parse(Base64.decode(window.__INITIAL_STATE__));
const store = configureStore(storeData);

const history = syncHistoryWithStore(browserHistory, store);
const root = document.getElementById("root");

if (DEV_SERVER) {
  require("./public/style/index.scss");
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>{Routers}</Router>
  </Provider>,
  root,
);

const App = () => {
  return (
    <Provider store={store}>
      <Router history={history}>{Routers}</Router>
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./clientApp.js